import React from 'react'
import OccyIcon from '../../app/components/svgIcons/OccyIcon'
import { StyledLabel } from '../../assets/styledComponents/Global'
import OccyLogoWhite from '../../app/components/svgIcons/OccyLogoWhite'
import styled, { useTheme } from 'styled-components'
import { useWindowSize } from '../../utils/helper'
import ClockIcon from '../../app/components/svgIcons/ClockIcon'
import moment from 'moment'
import StyledToolTip from '../../app/components/styledComponents/StyledToolTip'

const ProfileVideoHeader = ({ companyInfo, videoProfileRes, timeLeft }) => {
  const theme = useTheme()
  const isSmallScreen = useWindowSize();
  const formatTime = (seconds) => {
    if (!seconds) return "Expired";
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  return (
    <Header className={`d-flex justify-content-between `}> {!isSmallScreen && <div></div>} {companyInfo?.data?.job?.company?.compLOGOSignedUrl ?
      <img
        className='mb-3'
        src={companyInfo?.data?.job?.company?.compLOGOSignedUrl}
        alt={companyInfo?.data?.job?.company?.compLOGOSignedUrl || 'image'}
      /> : <OccyLogoWhite />} {isSmallScreen && videoProfileRes?.videoApplication?.allowedTime && timeLeft ?
        (
          <div className="d-flex align-items-center gap-2">
            <ClockIcon color={'white'} size={17} />
            <StyledLabel size="15px" fontWeight="500" color={theme?.white}>
              {timeLeft ? formatTime(timeLeft) : "Expired"}
            </StyledLabel>
          </div>
        ) : isSmallScreen && videoProfileRes && (
          <div className="d-flex align-items-center gap-2">
            <StyledToolTip
              title={`${moment(videoProfileRes?.videoApplication?.expireAt).fromNow(true) + " (" + moment(videoProfileRes?.videoApplication?.expireAt).format("Do MMM, h:mm A") + ")"}`}
              // className="mt-2"
              placement="bottom"
            >

              <ClockIcon color={'white'} size={17} className='me-2' />
              <StyledLabel size="15px" fontWeight="500" color={theme?.white}>
                {moment(videoProfileRes?.videoApplication?.expireAt).fromNow(true)}
              </StyledLabel>
            </StyledToolTip>
          </div>

        )} {!isSmallScreen && <div className='d-flex align-items-center gap-2'><OccyIcon size={20} /> <StyledLabel size='13px' weight='500' color={theme?.white}>Powered by Occy</StyledLabel> </div>}</Header>
  )
}

export default ProfileVideoHeader
const Header = styled.div`
  width: 100%;
  padding: 1rem;
  display:flex;
  align-items:center;
  color: #333;
  font-size: 1.5rem;
  background: linear-gradient(
    118.77deg,
    #1e1e1f -14.45%,
    #0d2349 57.39%,
    #1e1e1f 98.79%
  );
`;